'use client'

import { useState } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { ThemeToggle } from '@/components/ui/theme-toggle'
import { Logo } from '@/components/ui/logo'
import { TextLogo } from '@/components/ui/text-logo'

interface MobileNavProps {
  userEmail?: string | null
  onSignOut: () => void
}

export function MobileNav({ userEmail, onSignOut }: MobileNavProps) {
  const [open, setOpen] = useState(false)
  const pathname = usePathname()
  
  const routes = [
    { href: '/dashboard', label: 'Dashboard' },
    { href: '/dashboard/portfolio', label: 'Portfolio' },
    { href: '/dashboard/feed', label: 'Feed' },
    { href: '/dashboard/profile', label: 'Profile' },
    { href: '/crypto', label: 'Crypto' },
  ]
  
  const handleLinkClick = () => {
    setOpen(false)
  }
  
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className="md:hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left">
        <SheetHeader className="mb-6">
          <SheetTitle>
            <Logo width={40} height={40} />
          </SheetTitle>
        </SheetHeader>
        
        <div className="flex flex-col space-y-3">
          {routes.map((route) => (
            <Link
              key={route.href}
              href={route.href}
              onClick={handleLinkClick}
              className={`px-4 py-2 rounded-md ${
                pathname === route.href
                  ? 'bg-muted font-medium'
                  : 'hover:bg-muted/50'
              }`}
            >
              {route.label}
            </Link>
          ))}
          
          <div className="flex items-center px-4 py-2">
            <ThemeToggle />
            <span className="ml-2">Toggle theme</span>
          </div>
          
          {userEmail && (
            <div className="mt-auto pt-6 border-t">
              <p className="px-4 py-2 text-sm text-muted-foreground">
                {userEmail}
              </p>
              <Button 
                variant="outline" 
                className="w-full mt-2"
                onClick={() => {
                  setOpen(false)
                  onSignOut()
                }}
              >
                Sign Out
              </Button>
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  )
} 